import React, { useEffect, useState } from 'react';
import Header from './Components/Header';
import Footer from './Components/Footer';
import { fetchItems } from './api';
import ItemList from './Components/ItemList';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import NewsLetter from './Components/NewsLetter';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {

  const [items, setItems] = useState([]);
  const [altura, setAltura] = useState(false);
  useEffect(() => {
    const getItems = async () => {
      try {
        const data = await fetchItems();
        setItems(data);
        setAltura(true);
      } catch (error) {
        console.error('Error fetching items:', error);
      }
    };

    getItems();
  }, []);

  const empresas = [
    { id: 1, string: "Nuestros-clientes-PetroPeru-logo.png" },
    { id: 2, string: "Nuestros-clientes-Cepsa-logo.png" },
    { id: 3, string: "Nuestros-clientes-Cempro-logo.png" },
    { id: 4, string: "Nuestros-clientes-Dominion-logo.png" },
    { id: 5, string: "Nuestros-clientes-DEPC-logo.png" },
    { id: 6, string: "Nuestros-clientes-CPVEN-logo.png" },
    { id: 7, string: "Nuestros-clientes-JS-Industrial-logo.png" },
    { id: 8, string: "Nuestros-clientes-CEEC-logo.png" },
    { id: 9, string: "Nuestros-clientes-Distrito-La-Brea-logo.png" },
    { id: 10, string: "Nuestros-clientes-Lobitos-logo.png" },
    { id: 11, string: "Nuestros-clientes-Provincia-De-Talara-logo.png" },
    { id: 12, string: "Nuestros-clientes-Distrito-De-Mancora-logo.png" },

  ];
  const NuestrasSoluciones = [
    { id: 1, string: "Ámbito-Civil.png", title: "Ámbito Civil" },
    { id: 2, string: "Servicio-Generales.png", title: "Servicios Generales" },
    { id: 3, string: "Ámbito-Petrolero.png", title: "Ámbito Petrolero" },
    { id: 4, string: "Ámbito-PQ.png", title: "Ámbito PQ" },
    { id: 5, string: "Servicio-Generales.png", title: "Servicios Generales" },

  ];


  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1

  };

  const settingsMobile = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1

  };


  const settingsMobileLow = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1

  };

  const settings_home = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true
  };

  const useIsMobile = (breakpoint = 768) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < breakpoint);
      };

      window.addEventListener('resize', handleResize);

      // Limpia el evento cuando el componente se desmonta
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, [breakpoint]);

    return isMobile;
  };

  const useIsMobileLow = (breakpoint = 391) => {
    const [isMobileLow, setIsMobileLow] = useState(window.innerWidth < breakpoint);

    useEffect(() => {
      const handleResize = () => {
        setIsMobileLow(window.innerWidth < breakpoint);
      };

      window.addEventListener('resize', handleResize);

      // Limpia el evento cuando el componente se desmonta
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, [breakpoint]);

    return isMobileLow;
  };


  const isMobile = useIsMobile();
  const isMobileLow = useIsMobileLow();
  const settingsSlider = isMobileLow ? settingsMobileLow : isMobile ? settingsMobile : settings;

  return (
    <div className="page-wrapper">
      <Header />
      <section className="main-slider clearfix home">

        <Slider {...settings_home}>
          <div className="item swiper-slide">
            <div className="image-layer slider1Home" >

            </div>

            <div className="container-home">
              <div className="row">
                <div className="col-xl-12 col-lg-12">
                  <div className="main-slider__content">
                    <h2 className="main-slider__title">Soluciones Civiles</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className=" item swiper-slide">
            <div className="image-layer slider2Home" >

            </div>

            <div className="container-home">
              <div className="row">
                <div className="col-xl-12 col-lg-12">
                  <div className="main-slider__content">
                    <h2 className="main-slider__title">Soluciones Metal Mecánico</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="item swiper-slide">
            <div className="image-layer slider3Home" >

            </div>

            <div className="container-home">
              <div className="row">
                <div className="col-xl-12 col-lg-12">
                  <div className="main-slider__content">
                    <h2 className="main-slider__title">Soluciones Petroleras</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="item swiper-slide">
            <div className="image-layer slider4Home" >

            </div>

            <div className="container-home">
              <div className="row">
                <div className="col-xl-12 col-lg-12">
                  <div className="main-slider__content">
                    <h2 className="main-slider__title">Soluciones PQ</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="item swiper-slide">
            <div className="image-layer slider5Home" >

            </div>

            <div className="container-home">
              <div className="row">
                <div className="col-xl-12 col-lg-12">
                  <div className="main-slider__content">
                    <h2 className="main-slider__title">Soluciones Generales</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </section>

      <section className="project-two" style={{
        backgroundColor: '#e6e6e6',
        marginBottom: '0px', paddingTop: '60px', paddingBottom: '40px'
      }}>
        <div className="project-two__container">
          <div className={isMobile ? 'section-titleMobile text-center' : 'section-titleDesktop text-center'}>
            <h2 className={isMobile ? 'section-title__titleMobile' : 'section-title__titleDesktop'} style={{ marginTop: '0px' }}>VyL ASOCIADOS</h2>
            <h3 className={isMobile ? 'section-title__title2Mobile' : 'section-title__title2Desktop'} style={{ fontFamily: 'Axiforma-BoldItalic, sans-serif' }}>Calidad y experiencia</h3>
          </div>

          <div className="project-two__bottomHome">
            <div className={isMobile ? 'calidadExperienciaMobile' : 'calidadExperienciaDesktop'}>
              <div style={{ flex: '0 0 auto' }}>
                <img
                  src="/assets/images/resources/Ícono-+10-años-de-experiencia.png"
                  alt="4 años de experiencia"
                  style={{
                    width: '120px',
                    height: 'auto',
                    objectFit: 'contain'
                  }}
                />
              </div>
              <div style={{
                textAlign: 'center',
                color: '#000000',
                fontSize: '24px',
                fontWeight: '600',
                lineHeight: '1.4',

              }}>
                +4 años de experiencia en<br />
                la externalización de<br />
                servicios generales
              </div>
            </div>
          </div>
          <div className="row viewMore">
            <div className="main-menu__btn-box">
              <Link to="/about" className="thm-btn main-menu__btn"> CONOCE MAS &raquo;</Link>
            </div>
          </div>
        </div>
      </section>

      <section className="project-two" style={{ marginBottom: '0px', paddingTop: '60px', paddingBottom: '40px' }}>
        <div className="project-two__container">
          <div className="section-title text-center">
            <h2 className={isMobile ? 'section-title__titleNS1Mobile' : 'section-title__titleNS1Desktop'}>NUESTRAS SOLUCIONES</h2>
          </div>
          {!isMobile ?
            (<div className="row" style={{ display: 'flex', justifyContent: 'center', gap: '30px', flexWrap: 'wrap' }}>
              {/* Ámbito Civil */}
              <div className="col-lg-4 col-md-6" style={{ maxWidth: '450px' }}>
                <Link to="/solutions" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <div style={{
                    backgroundColor: '#fff',
                    borderRadius: '15px',
                    overflow: 'hidden',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    cursor: 'pointer'
                  }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-10px)';
                      e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                    }}>
                    <div style={{ height: '450px', overflow: 'hidden' }}>
                      <img
                        src="/assets/images/resources/Ámbito-Civil.png"
                        alt="Ámbito Civil"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                      />
                    </div>
                    <div style={{
                      padding: '25px',
                      textAlign: 'center',
                      backgroundColor: '#1e4a72',
                      color: 'white'
                    }}>
                      <h3 style={{
                        fontSize: '22px',
                        fontWeight: '600',
                        margin: '0',
                        fontFamily: 'Axiforma-Regular, sans-serif',
                        color: 'white'
                      }}>
                        Ámbito Civil
                      </h3>
                    </div>
                  </div>
                </Link>
              </div>

              {/* Servicios Generales */}
              <div className="col-lg-4 col-md-6" style={{ maxWidth: '450px' }}>
                <Link to="/solutions" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <div style={{
                    backgroundColor: '#fff',
                    borderRadius: '15px',
                    overflow: 'hidden',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    cursor: 'pointer'
                  }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-10px)';
                      e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                    }}>
                    <div style={{ height: '450px', overflow: 'hidden' }}>
                      <img
                        src="/assets/images/resources/Servicio-Generales.png"
                        alt="Servicios Generales"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                      />
                    </div>
                    <div style={{
                      padding: '25px',
                      textAlign: 'center',
                      backgroundColor: '#1e4a72',
                      color: 'white'
                    }}>
                      <h3 style={{
                        fontSize: '22px',
                        fontWeight: '600',
                        margin: '0',
                        fontFamily: 'Axiforma-Regular, sans-serif',
                        color: 'white'
                      }}>
                        Servicios Generales
                      </h3>
                    </div>
                  </div>
                </Link>
              </div>

              {/* Ámbito Petrolero */}
              <div className="col-lg-4 col-md-6" style={{ maxWidth: '450px' }}>
                <Link to="/solutions" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <div style={{
                    backgroundColor: '#fff',
                    borderRadius: '15px',
                    overflow: 'hidden',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    cursor: 'pointer'
                  }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-10px)';
                      e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                    }}>
                    <div style={{ height: '450px', overflow: 'hidden' }}>
                      <img
                        src="/assets/images/resources/Ámbito-Petrolero.png"
                        alt="Ámbito Petrolero"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                      />
                    </div>
                    <div style={{
                      padding: '25px',
                      textAlign: 'center',
                      backgroundColor: '#1e4a72',
                      color: 'white'
                    }}>
                      <h3 style={{
                        fontSize: '22px',
                        fontWeight: '600',
                        margin: '0',
                        fontFamily: 'Axiforma-Regular, sans-serif',
                        color: 'white'
                      }}>
                        Ámbito Petrolero
                      </h3>
                    </div>
                  </div>
                </Link>
              </div>
            </div>) :
            (

              <div className='mobile-brand-carousel' >
                <Slider  {...settingsSlider}>
                  {NuestrasSoluciones.map(item => (
                    <div className="item brand-one__single" key={item.id} style={{
                      flex: '0 0 auto',
                      borderRadius: '15px',
                      overflow: 'hidden',
                      position: 'relative',
                      width: isMobile ? '280px' : '350px',
                      margin: isMobile ? '0 10px' : '0 15px'
                    }}>
                      <div style={{ height: '250px', position: 'relative' }}>
                        <img
                          src={`assets/images/resources/${item.string}`}
                          alt={item.title}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                          }}
                        />
                      </div>
                      <div style={{
                        padding: '20px',
                        textAlign: 'center',
                        backgroundColor: '#023352',
                        color: 'white'
                      }}>
                        <h3 style={{
                          fontSize: '20px',
                          fontWeight: '600',
                          margin: '0',
                          fontFamily: 'Axiforma-Regular, sans-serif',
                          color: 'white'
                        }}>
                          {item.title}
                        </h3>
                      </div>
                    </div>
                  ))}
                </Slider>

              </div>

            )}

          <div className="row viewMore" style={{ marginTop: '40px' }}>
            <div className="main-menu__btn-box">
              <Link to="/solutions" className="thm-btn main-menu__btn"> CONOCE MAS &raquo;</Link>
            </div>
          </div>
        </div>
      </section>


      <section className="services-one">

        <div className="container">
          <div className="services-one__top">
            <div className="row">
              <div className="col-xl-12 col-lg-12">
                <div className="services-one__top-left">
                  <div className="section-title text-center">

                    <h2 className="section-title__title">NUESTROS CLIENTES</h2>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <Slider {...settingsSlider}>
                  {empresas.map(item => (
                    <div className="item brand-one__single" key={item.id}>
                      <div className="brand-one__img">
                        <img src={`assets/images/business/${item.string}`} alt="" />
                      </div>
                    </div>
                  ))}
                </Slider>

              </div>

            </div>

          </div>
        </div>
      </section>

      <NewsLetter />


      <Footer />
    </div>
  );
}

export default Home;

